import * as React from "react";
import { useMemo } from "react";
import TableFetchContext from "./TableFetchContext";
const TableFetchContextProvider = ({ children = void 0, refetch, attributes, entityTableId }) => {
  const contextValue = useMemo(
    () => ({
      refetch,
      attributes,
      entityTableId
    }),
    [refetch, attributes, entityTableId]
  );
  return /* @__PURE__ */ React.createElement(TableFetchContext.Provider, { value: contextValue }, children);
};
export default TableFetchContextProvider;
